import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@ngneat/reactive-forms';
import { map } from 'rxjs/operators';
import { Realisation } from '../../classes/realisation';
import { User } from '../../classes/user.class';
import { CodaltComponent } from '../../codalt.component';
import { RealisationService } from '../../services/realisation.service';
import { UserService } from '../../services/user/user.service';

@Component({
    selector: 'app-move-realisations-to-performer-dialog',
    standalone: false,
    templateUrl: './move-realisations-to-performer-dialog.component.html',
    styleUrl: './move-realisations-to-performer-dialog.component.scss',
})
export class MoveRealisationsToPerformerDialogComponent extends CodaltComponent {
    fcPerformerSearch = new FormControl<string>();

    executors$ = this.userService
        .getList()
        .pipe(map(users => users.filter(user => user.roles.find(r => this.environment.executors.includes(r.key)))));

    saving = false;

    constructor(
        public dialogRef: MatDialogRef<MoveRealisationsToPerformerDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            realisations: Realisation[];
        },
        private realisationService: RealisationService,
        private userService: UserService
    ) {
        super();
    }

    setExecutor(executor: User) {
        if (!this.saving) {
            this.saving = true;
            this.subscriptions.add(
                this.realisationService
                    .moveRealisationsToPerformer(
                        this.data.realisations.map(r => r.id),
                        executor.id
                    )
                    .subscribe(() => {
                        this.dialogRef.close(true);
                    })
            );
        }
    }
}
